import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import PremiumAd from '../Common/Ad/PremiumAd';
import 'bootstrap/dist/css/bootstrap.min.css';
import Auth from '../Common/Auth';

import Common from '../Common';

const suitCodeTranslator = {
    "d": "Diamond (\u2666)",
    "c": "Club (\u2663)",
    "h": "Heart (\u2665)",
    "s": "Spade (\u2660)",
}

class OpponentWinAnalysisDiv extends Component {
    generateOpponentAnalysisText = () => {
        let handType = this.props.handInfoObj.type
        let winProb = this.props.handInfoObj.prob*100
        winProb = winProb.toFixed(2)
        let handCharacteristic = this.props.handInfoObj.characteristic
        let infoText = ""

        switch(handType) {
            case "suit":
                handCharacteristic = suitCodeTranslator[handCharacteristic]
                infoText = `${winProb}% - a hand with suit of ${handCharacteristic}`
                break
            case "singleNum":
                infoText = `${winProb}% - a hand with a ${handCharacteristic}`
                break
            case "pairNum":
                handCharacteristic = handCharacteristic[0] + ", " + handCharacteristic[2]
                infoText = `${winProb}% - a pair of ${handCharacteristic}`
                break
            default:
                break
        }

        return infoText
    }

    render() {
        let infoText = this.generateOpponentAnalysisText()

        return (
            <div className="mb-2">
                {infoText}
            </div>
        )
    }
}

class AdvicePanel extends Component {
    getAdviceText = () => {
        let adviceText = ""

        if(this.props.state.action === "Bet") {
            adviceText = <span><b>Bet</b> smartly. By the river card, total chip bets should be near the max % of chips at the start of the round (shown below).</span>
        } else if(this.props.state.action === "Check") {
            adviceText = <span><b>Check</b> or Bet as little as possible. Fold if opponent's bet size is too aggressive.</span>
        } else {
            adviceText = <b>{this.props.state.action}</b>
        }

        return adviceText
    }

    getBestBetDivs = () => {
        let optimalBetPctList = this.props.state.optimalBet.betRatio
        let minOtherPlayersList = this.props.state.optimalBet.paybackRatio
        let bestBetDivs = []

        let optimalBetPct = -1

        for(let i=0; i<optimalBetPctList.length; i++) {
            optimalBetPct = optimalBetPctList[i]*100

            if(optimalBetPct > 0) {
                if(minOtherPlayersList[i] >= 2) {
                    bestBetDivs.push(<div key={i}>{optimalBetPct.toFixed(2)} % when {minOtherPlayersList[i]} other players are betting</div>)
                } else if(minOtherPlayersList[i] === 1) {
                    bestBetDivs.push(<div key={i}>{optimalBetPct.toFixed(2)} % when 1 other player is betting</div>)
                }
            } else {
                if(minOtherPlayersList[i] >= 2) {
                    bestBetDivs.push(<div key={i}>&lt;2% when {minOtherPlayersList[i]} other players are betting</div>)
                } else if(minOtherPlayersList[i] === 1) {
                    bestBetDivs.push(<div key={i}>&lt;2% when 1 other player is betting</div>)
                }
            }
            
        }

        return bestBetDivs
    }

    shouldShowBetSize = (action) => {
        return (action === "Bet" || action === "Check")
    }

    render() {
        return(
            <div>
                <Row>
                    <Col xs="12" className="mb-4">
                        <span className="pr-2">
                            <b>Action: </b>
                        </span>
                        <span className={this.props.state.analysisColorClass}>
                            {this.getAdviceText()}
                        </span>
                    </Col>
                </Row> 
                { this.shouldShowBetSize(this.props.state.action) && (
                    <Row>
                        <Col xs="12" className="mb-3">
                            <b>Total Max Bet Pct of Your Chip: </b>
                        </Col>
                        <Col xs="12">
                            {this.getBestBetDivs()}
                        </Col>
                    </Row>
                )}
            </div>
        )
    }
}

class AnalysisResult extends Component {
    cardSpan(card) {
        let cardWithSuit = Common.convertCardStringToSuits(card)

        if(card.includes('h') || card.includes('d')) {
            return (<span className="red">{cardWithSuit}</span>)
        } else {
            return (<span>{cardWithSuit}</span>)
        }
    }

    handStringJsx() {
        let hand1 = this.cardSpan(this.props.state.myFirstCard)
        let hand2 = this.cardSpan(this.props.state.mySecondCard)

        return (<span>{hand1}, {hand2}</span>)
    }

    sharedStringJsx() {
        let numOfCards = 0

        for(let i=0; i<this.props.state.communityCards.length; i++) {
            if(this.props.state.communityCards[i].length >= 2) {
                numOfCards = i + 1;
            } else {
                break;
            }
        }

        return (
            <span>
                {this.props.state.communityCards.map((card, i) => {
                    if(i < numOfCards - 1) {
                        let cardJsx = this.cardSpan(card)
                        return (<span key={i}>{cardJsx}, </span>)
                    }

                    if(i == numOfCards - 1) {
                        let cardJsx = this.cardSpan(card)
                        return (<span key={i}>{cardJsx}</span>)
                    }

                    return (<span key={i}></span>)
                })}
            </span>
        )
    }

    render() {
        let auth = new Auth(null);
        let token = auth.getLocalToken()

        let handString = this.handStringJsx()

        let sharedString = "n/a"

        if(this.props.state.communityCards[0] !== "") {
            sharedString = this.sharedStringJsx()
        } 

        return (
        <Row>
            {this.props.shouldShow === true && (
                <Col xs="12" sm="6">
                    <div className="font-12">
                        Hand: {handString}
                    </div>
                </Col>
            )}
            {this.props.shouldShow === true && (
                <Col xs="12" sm="6" className="mb-3">
                    <div className="font-12">
                        Shared: {sharedString}
                    </div>
                </Col>
            )}
            <Col xs="12" sm="6" className="mb-3">
                <Row>
                    <Col xs="12" className="mt-3 mb-3">
                        <h5>Estimated Outcomes</h5>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" className="mb-4">
                        <span className="pr-3">
                            <b>
                                Hand Rank (
                                <a href="/resources/poker-hand-rankings" target="_blank">
                                    ?
                                </a>
                                ):
                            </b>
                        </span>
                        <span>
                            <b>{this.props.state.handRank}</b>
                        </span>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" className="mb-4">
                        <div>
                            <span className="pr-3">
                                <b>My Win Rate: </b>
                            </span>
                            <span className={this.props.state.analysisColorClass}>
                                <b>{this.props.state.myWinRate} %</b>
                            </span>
                        </div>
                        { !token && (
                            <div className="mt-1 font-12">
                                (Assumes no player folds their hand)
                            </div>
                        ) }
                        
                    </Col>
                    
                </Row>

                {this.props.state.opponentsWinningHandStatus !== 'ok' ? (
                    <Row>
                        <Col xs="12" className="mb-4">
                            <span className="pr-3">
                                <b>Opponents' Win Rate: </b>
                            </span>
                            <span>
                                <b>{this.props.state.opponentsWinRate} %</b>
                            </span>
                        </Col>
                    </Row>
                ):(
                    <Row>
                        <Col xs="12" className="mb-3">
                            <b>Top hands you could lose to: </b>
                        </Col>
                        { this.props.state.top5OpponentHand.map((handInfoObj, i) => (
                            <Col xs="12" key={i}>
                                <OpponentWinAnalysisDiv handInfoObj={handInfoObj} />
                            </Col>
                        ))}
                    </Row>
                )}
                
            </Col>
            <Col xs="12" sm="6" className="mb-3">
                <Row>
                    <Col xs="12" className="mt-3 mb-3">
                        <h5>Advice</h5>
                    </Col>
                </Row>
                <AdvicePanel state={this.props.state}/>
            </Col>

            {/* <Col xs="12" className="mb-4 mt-4">
                <PremiumAd/>
            </Col> */}
        </Row>
        )
    }
}

export default AnalysisResult;